module.exports = __webpack_public_path__ + "static/img/ent-84.38228c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-84.jpg
// module id = WU2N
// module chunks = 52